import { signOut } from 'aws-amplify/auth';
import { ReactNode, useState } from 'react';
import { useNavigate } from 'react-router';
import { PushNotificationSubscriptionInput } from '@/__generated__/graphql.ts';
import { paths } from '@/routes-utils/paths.ts';
import { useRemovePushSubscription } from '@/routes/_app.p.settings.notifications_.$type/use-remove-push-subscription.ts';
import { pushService } from '@/services/push-service.ts';
import { traceError } from '@/utils/trace-error.ts';

interface LogoutButtonProps {
  renderTrigger: (props: { loading: boolean; logout: () => void }) => ReactNode;
  navigateTo?: string;
}

export const LogoutButton = ({
  renderTrigger,
  navigateTo,
}: LogoutButtonProps) => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [removePushSubscription] = useRemovePushSubscription();

  const logout = async () => {
    setLoading(true);
    try {
      const subscription = await pushService.getSubscription();
      if (subscription) {
        const { data } = await removePushSubscription(
          subscription as PushNotificationSubscriptionInput,
        );
        if (data?.removePushNotificationsSubscription) {
          await subscription.unsubscribe();
        }
      }
    } catch (err) {
      traceError(
        new Error('Failed to unsubscribe from push notifications on logout', {
          cause: err,
        }),
      );
    }
    // Leave Privy alone for same-user re-login. A different Synoptic user is
    // handled by PrivySynopticUserGuard on the next terminal visit.
    await signOut();
    navigate(navigateTo || paths.login);
    setLoading(false);
  };

  return renderTrigger({ loading, logout });
};
